<template>
  <div class="offlinecs-fa">
    <el-scrollbar
      wrapStyle="overflow-x:hidden;"
      :style="`height:${scroll_height}px`"
    >
      <div
        class="offline-item"
        v-for="(item, index) in offlinebindlist"
        :key="item.index"
      >
        <div class="offline-item-label" style="width:50px">
          {{ index + 1 }}
        </div>
        <div class="offline-item-label">
          {{ item.label }}
        </div>
        <div class="offline-item-value">
          {{ item.value }}
        </div>
        <div
          v-if="selectshow"
          v-loading="!selectshow"
          class="offline-item-value"
          style="width:250px !important"
        >
          <el-select
            size="mini"
            filterable
            v-model="item.inline"
            style="width:250px !important"
            @change="
              val => {
                selectChange(val, item);
              }
            "
            :placeholder="`请选择线上${who == 'classinfo' ? '类别' : '供应商'}`"
          >
            <el-option
              v-for="items in systemlist"
              :key="items.value"
              :label="items.value"
              :value="items.value"
            >
              <div style="float: left">
                {{ items.label }}
              </div>
              <div class="el-select-r" style="">{{ items.value }}</div>
            </el-option>
          </el-select>
        </div>
        <!--  -->
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import { supplierSync, classifySync } from "@/api/offlinestores.js";
export default {
  name: "offlinecs",
  props: ["who", "offlinelist", "scroll_height", "systemlist"],
  data() {
    return {
      offlinebindlist: [],
      selectshow: false,
      indexclass: ""
    };
  },
  mounted() {
    console.log(this.offlinelist);
    const that = this;
    setTimeout(()=>{
      that.setOfflineList(that.offlinelist);
    },100)
    
  },
  methods: {
    setOfflineList(list) {
      const that = this;

      var offlinebindlist = list;

      for (let j = 0; j < offlinebindlist.length; j++) {
        for (let i = 0; i < that.systemlist.length; i++) {
          if (
            offlinebindlist[j].inline &&
            offlinebindlist[j].inline.trim() == that.systemlist[i].label.trim()
          ) {
            offlinebindlist[j].inline = that.systemlist[i].value;
          }
        }
      }
      that.offlinebindlist = offlinebindlist;
      that.selectshow = true;
    },
    /**
     *
     * @param {*} e 返回的线上类别
     * @param {*} item 线下类别
     */
    selectChange(e, item) {
      var value = ""; //线上
      for (let i = 0; i < this.systemlist.length; i++) {
        if (this.systemlist[i].value == e) {
          value = this.systemlist[i].label;
        }
      }
      if (this.who == "supplier") {
        //TODO:未绑定成功
        supplierSync(value, item.label).then(res => {
          if (this.testR(res)) {
            if (res.data.resp_data.isSuccess) {
              this.successMessage("成功绑定线下供应商！");
            } else {
              this.warnMessage("绑定线下供应商失败！");
            }
          }
        });
      } else if (this.who == "classinfo") {
        classifySync(value, item.label).then(res => {
          if (res.data.resp_data.isSuccess) {
            this.successMessage("成功绑定线下类别！");
          } else {
            this.warnMessage("绑定线下类别失败！");
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.offlinecs-fa {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.offline-item {
  display: flex;
  align-items: center;
  height: 30px;
  .offline-item-label {
    width: 120px;
    color: #409eff;
    text-align: left;
  }
  .offline-item-value {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 10px;
  }
}
.el-select-r {
  float: right;
  color: #8492a6;
  font-size: 13px;
  width: 200px;
  text-align: right;
}
</style>
